import React, { forwardRef } from 'react'

import {
  arrow,
  dark,
  left,
  light,
  right,
  roundScrollDown,
  scrollDownCta,
} from './ArrowBtnComponent.module.css'

const ArrowBtn = forwardRef(({ className, direction, theme }, ref) => {
  const directionClass = direction === 'left' ? left : right
  const themeClass = theme === 'dark' ? dark : light

  return (
    <div ref={ref} className={`${className} ${roundScrollDown} ${themeClass}`}>
      <div className={scrollDownCta}>
        <span className={`${arrow} ${directionClass}`} />
      </div>
    </div>
  )
})

export default ArrowBtn
